import { HttpService } from '~/helpers';
import { UserService } from '~/services';

const endpoint = 'movimento/frequencia';

const formatValues = values => ({
  ...values,
  usuario: UserService.getUser().login,
  cliente: UserService.getUser().codigo,
});

const FrequenciaService = {
  getAllHistorico: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'getAllHistorico', [formatValues(values)], onSuccess, onError);
  },
  getHistoricoResumo: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'getHistoricoResumo', [formatValues(values)], onSuccess, onError);
  },
  consultarCupom: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'consultarCupom', [values], onSuccess, onError);
  },
  getAllVeiculo: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'getAllVeiculo', [formatValues(values)], onSuccess, onError);
  },
  salvarVeiculo: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'salvarVeiculo', [formatValues(values)], onSuccess, onError);
  },
  excluirVeiculo: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'excluirVeiculo', [formatValues(values)], onSuccess, onError);
  },
};

export default FrequenciaService;
